import { useTranslation } from 'react-i18next'
import { FieldInput, MaskedInput } from '@/components/form'

type Range = {
  value?: string
  selection?: {
    start?: number
    end?: number
  }
}

// Convert Postal Code to Uppercase
const upperCase: any = (...args: Range[]) => {
  const [newState] = args
  const original = newState
  if ('value' in original) original.value = original?.value?.toUpperCase()
  return original
}

type ZipCodeInputProps = {
  country?: string
  required?: boolean
  autocompletePrefix?: string
}

const StateDropdown: React.FC<ZipCodeInputProps> = ({
  country: initialCountry = 'ca',
  required = false,
  autocompletePrefix = '',
  ...rest
}) => {
  const { t } = useTranslation()
  const country = initialCountry
  const getField = (): React.ReactNode => {
    if (country === 'ca')
      return (
        <MaskedInput
          id="zip"
          name="zip"
          autoComplete={`${autocompletePrefix} postal-code`}
          format="a9a 9a9"
          placeholder={t('l.payment_settings.edit.postal_code.label', 'Postal code')}
          required={required}
          beforeMaskedValueChange={upperCase}
          keepSpace
          {...rest}
        />
      )
    if (country === 'us')
      return (
        <MaskedInput
          id="zip"
          name="zip"
          autoComplete={`${autocompletePrefix} postal-code`}
          format="99999"
          placeholder={t('l.payment_settings.edit.zip_code.label', 'ZIP code')}
          required={required}
          {...rest}
        />
      )
    return (
      <FieldInput
        id="zip"
        name="zip"
        autoComplete={`${autocompletePrefix} postal-code`}
        placeholder={t('l.payment_settings.edit.postal_code.label', 'Postal code')}
        required={required}
        {...rest}
      />
    )
  }
  return <>{getField()}</>
}

export default StateDropdown
